// Centralised i18n dictionary for AstroFate.
//
// Hindi values intentionally mix Hindi + Hinglish where it feels natural to
// Indian users — astrology terms like "Kundli", "Pooja", "Lagna", "Rashi",
// brand name "AstroFate", and Western numerals stay as-is.
// Add keys in lowercase.dot.notation grouped by surface (navbar.*, home.*).

export const translations = {
  en: {
    // ── Navbar ────────────────────────────────────────────────────────
    "nav.kundli": "Kundli",
    "nav.aiChat": "AI Chat",
    "nav.consult": "Consult",
    "nav.blog": "Blog",
    "nav.dashboard": "Dashboard",
    "nav.admin": "Admin",
    "nav.login": "Login",
    "nav.signup": "Sign Up",
    "nav.getStarted": "Get Started",
    "nav.logout": "Logout",
    "nav.languageEN": "EN",
    "nav.languageHI": "हिं",

    // ── Home: Hero ────────────────────────────────────────────────────
    "home.badge": "Ancient Vedic Wisdom. Modern AI Precision.",
    "home.heroTitle1": "Discover Your",
    "home.heroTitle2": "True Path",
    "home.heroSubtitle": "Personalized Guidance for Life, Healing & Growth",
    "home.heroDesc": "AstroFate helps you understand yourself, navigate challenges, and grow with confidence through personalized insights, AI guidance, and ancient wisdom. Find clarity in relationships, career, well-being, and purpose.",
    "home.heroTagline": "Find Answers. Heal with Awareness. Grow with Confidence.",
    "home.heroCtaChat": "Ask Free AI Question",
    "home.heroCtaKundli": "Get Full Kundli Report",
    "home.statsReports": "Reports",
    "home.statsUsers": "Happy Users",
    "home.statsRating": "Rating",

    // ── Home: Features ────────────────────────────────────────────────
    "home.featuresHeading": "What AstroFate Offers",
    "home.feat1Title": "AI Kundli Report",
    "home.feat1Desc": "Complete Vedic birth chart analysis with planetary positions, yogas, doshas, and dasha periods.",
    "home.feat1Cta": "Get Report",
    "home.feat2Title": "AI Astrology Chat",
    "home.feat2Desc": "Ask in-depth questions to our AI astrologer trained on thousands of Vedic texts.",
    "home.feat2Cta": "Start Chat",
    "home.feat3Title": "Human Consultation",
    "home.feat3Desc": "Book a session with expert Vedic astrologers for deep personal guidance and remedies.",
    "home.feat3Cta": "Book Now",

    // ── Home: Free question CTA ───────────────────────────────────────
    "home.freeQTitle": "Ask One Free Question",
    "home.freeQDesc": "Get a personalized AI astrology answer — completely free. No credit card required.",
    "home.freeQCta": "Start Your Free Chat",

    // ── Home: Pricing ─────────────────────────────────────────────────
    "home.pricingHeading": "Simple Pricing",
    "home.priceAiChat": "AI Chat",
    "home.priceAiChatPeriod": "24 hours",
    "home.priceAiChatBadge": "Most Popular",
    "home.priceAiChatFeat1": "4 AI questions",
    "home.priceAiChatFeat2": "Personalized chart memory",
    "home.priceAiChatFeat3": "Remedies & guidance",
    "home.priceAiChatFeat4": "Career & love analysis",
    "home.priceConsult": "Consult Astrologer",
    "home.priceConsultPeriod": "15 min live chat",
    "home.priceConsultBadge": "50% OFF",
    "home.priceConsultFeat1": "Live human consultation",
    "home.priceConsultFeat2": "Priority report generation",
    "home.priceConsultFeat3": "Personalized remedies",
    "home.priceConsultFeat4": "Marriage & career analysis",
    "home.priceGetStarted": "Get Started",

    // ── Home: Testimonials ────────────────────────────────────────────
    "home.testimonialsHeading": "What Our Users Say",

    // ── Footer ────────────────────────────────────────────────────────
    "footer.tagline": "Ancient Vedic wisdom. Modern AI precision. Personalized guidance for your life path.",
    "footer.quickLinks": "Quick Links",
    "footer.home": "Home",
    "footer.aiChat": "AI Chat",
    "footer.bookConsult": "Book Consultation",
    "footer.blog": "Blog",
    "footer.dashboard": "Dashboard",
    "footer.policies": "Policies",
    "footer.contact": "Contact Us",
    "footer.terms": "Terms & Conditions",
    "footer.refunds": "Refunds & Cancellations",
    "footer.contactHeading": "Contact",
    "footer.allRights": "All rights reserved.",
    "footer.payments": "Prices in INR · Payments by Cashfree",

    // ── Auth ──────────────────────────────────────────────────────────
    "auth.welcomeBack": "Welcome Back",
    "auth.createAccount": "Create your account",
    "auth.tabLogin": "Login",
    "auth.tabSignup": "Sign Up",
    "auth.nameLabel": "Name",
    "auth.emailLabel": "Email",
    "auth.passwordLabel": "Password",
    "auth.namePh": "Your full name",
    "auth.emailPh": "you@gmail.com",
    "auth.passwordPh": "••••••••",
    "auth.submitLogin": "Login",
    "auth.submitSignup": "Create Account",
    "auth.switchToSignup": "Don't have an account? Sign up",
    "auth.switchToLogin": "Already have an account? Log in",
    "auth.forgot": "Forgot password?",

    // ── BirthForm ─────────────────────────────────────────────────────
    "birth.title": "Get Full Kundli Report",
    "birth.subtitle": "Start here — enter your birth details for a personalized Vedic report, then chat with AI or book a live astrologer.",
    "birth.name": "Full Name",
    "birth.namePh": "Your name",
    "birth.day": "Day",
    "birth.month": "Month",
    "birth.year": "Year",
    "birth.hour": "Hour",
    "birth.minute": "Minute",
    "birth.period": "AM/PM",
    "birth.city": "Birth City",
    "birth.cityPh": "e.g. Mumbai, Delhi…",
    "birth.generate": "Generate My Kundli Report",
    "birth.generating": "Generating your Kundli…",

    // ── Chat ──────────────────────────────────────────────────────────
    "chat.suggestedHeading": "Suggested Questions",
    "chat.inputPh": "Ask anything about your life, career, love…",
    "chat.sendBtn": "Send",
    "chat.loginRequired": "Login required to ask a question",
    "chat.loginRequiredDesc": "Free account · Get your 1st AI question free · Takes 10 sec",
    "chat.loginToStart": "Login to Start",
    "chat.loginToAsk": "Login to Ask",
    "chat.noChart": "No Chart Loaded",
    "chat.noChartDesc": "Generate your Kundli first for personalized answers",
    "chat.getKundli": "Get Detailed Kundli Report",
    "chat.questionsRemaining": "{n} questions remaining",
    "chat.outOfQuestions": "You've used all your AI questions. Recharge to continue.",
    "chat.rechargeCta": "Recharge AI Chat — {price}",

    // ── Kundli gate (chat) ────────────────────────────────────────────
    "chart.gateTitle": "Enter your birth details first",
    "chart.step1": "Step 1 of 2 · Birth details",
    "chart.stepTitle": "First, let's read your chart",
    "chart.stepDesc": "Every answer comes from your own Vedic chart — so we need your date, time and place of birth. Pick them or type them, whichever is quicker.",
    "chart.formTitle": "Your birth details",
    "chart.formSub": "Use the calendar and clock, or tap “Type it” to key the numbers in.",
    "chart.yourQuestion": "Your question is saved",
    "chart.backToChat": "Back to chat",
    "chart.chartReady": "Your chart is ready",
    "chart.firstRead": "Your first read from this chart",
    "chart.startChat": "Ask your question",
    "chart.detailsToggle": "Chart details",
    "chart.gateDesc": "AstroFate AI answers only from your Kundli. Add your date, time and place of birth — it takes 20 seconds.",
    "chart.dob": "Date of Birth",
    "chart.tob": "Time of Birth",
    "chart.connectBtn": "Connect My Kundli",
    "chart.connecting": "Reading your Kundli…",
    "chart.genFailed": "Couldn't build your Kundli. Please check the details and try again.",
    "chart.connected": "Kundli connected",
    "chart.connectedMsg": "Your Kundli is connected. Ask your question — every answer will be read from your chart.",
    "chart.needDetails": "Before I can answer, I need your birth details — date, time and place of birth. Please fill the form below and I'll read your Kundli.",
    "chart.loading": "Connecting your Kundli…",
    "chart.readyGuest": "Your Kundli is ready — I've read your chart. Ask your first question below, it's FREE. You'll create a free account only when you send it, so your report and answer are saved for you.",
    "chat.guestStart": "Add your birth details below — no login needed. Your first chart question is FREE.",
    "chat.guestReady": "Your chart is ready. Type your first question — it's FREE.",
    "chat.guestHint": "Free account created when you send · 1st question FREE · No card needed",
    "chat.guestPlaceholder": "Ask your first question free…",
    "chat.viewFullReport": "View full Kundli report",
    "auth.questionSaved": "Your question is saved — create a free account and your answer appears instantly",
    "report.saveTitle": "Save this report to your free account",
    "report.saveDesc": "Get it emailed as a PDF, open it any time from your dashboard, and unlock 1 FREE AI question about this chart.",
    "report.saveCta": "Create free account",
    "chart.selectLabel": "Reading chart of",
    "chart.addAnother": "+ Add new birth details",
    "chart.inputLockedPh": "Enter your birth details to ask…",
    "chart.chooseTitle": "Which Kundli should I read?",
    "chart.choosePrompt": "You have multiple Kundlis saved. Please pick whose chart I should use for this question.",
    "chart.useThis": "Use this",

    // ── Chart at a glance ─────────────────────────────────────────────
    "glance.title": "Your Chart at a Glance",
    "glance.lagna": "Lagna",
    "glance.sun": "Sun Sign",
    "glance.moon": "Moon Sign",
    "glance.nakshatra": "Nakshatra",
    "glance.dasha": "Current Dasha",
    "glance.until": "until",
    "glance.downloadPdf": "Download PDF",
    "glance.preparingPdf": "Preparing PDF…",
    "glance.pdfFailed": "Couldn't create the PDF. Please try again.",
    "pdf.langEn": "English",
    "pdf.langHi": "हिन्दी",
    "pdf.hindiWait": "Translating your report to Hindi — this takes up to a minute the first time.",
    "pdf.emailBtn": "Email me this PDF",
    "pdf.emailing": "Sending…",
    "pdf.emailed": "Sent! Check your inbox at",
    "pdf.emailFailed": "Couldn't send the email. Please try again.",
    "pdf.autoSent": "We've also emailed this report to you.",

    // ── Daily horoscope ───────────────────────────────────────────────
    "horo.title": "Today's Horoscope",
    "horo.loading": "Reading today's transits for your chart…",
    "horo.failed": "Couldn't load today's horoscope. Please try again.",
    "horo.retry": "Try again",
    "horo.loginNeeded": "Log in to see today's prediction from your own Kundli.",
    "horo.askAi": "Ask AI about today",
    "horo.askPrefill": "What does today's horoscope mean for my career?",
    "horo.dashTitle": "Today's Horoscope",
    "horo.dashCta": "Read today's horoscope",
    "horo.dashEmpty": "Generate your Kundli to unlock daily chart-based predictions.",

    // ── Kundli Matching ───────────────────────────────────────────────
    "match.navLabel": "Matching",
    "match.title": "Kundli Matching",
    "match.subtitle": "Free Ashtakoot compatibility score out of 36 — unlock the detailed report for {price}.",
    "match.partner1": "Partner 1 (Groom)",
    "match.partner2": "Partner 2 (Bride)",
    "match.useSaved": "Use a saved Kundli",
    "match.manual": "Enter manually",
    "match.checkBtn": "Check Compatibility — Free",
    "match.checking": "Reading both charts…",
    "match.failed": "Couldn't match these charts. Please check the details and try again.",
    "match.scoreOf": "out of 36",
    "match.kootaTable": "Koota-by-koota breakdown",
    "match.koota": "Koota",
    "match.points": "Points",
    "match.details": "Details",
    "match.meaning": "What it covers",
    "match.doshas": "Doshas found",
    "match.noDoshas": "No major doshas found",
    "match.manglik": "Manglik",
    "match.unlockCta": "Unlock full match report — {price}",
    "match.unlockTitle": "Full Match Report",
    "match.unlockDesc": "A detailed Vedic analysis of this match, written from both charts.",
    "match.feat1": "Koota-by-koota expert analysis",
    "match.feat2": "Emotional, physical & family compatibility",
    "match.feat3": "Dosha impact and practical remedies",
    "match.feat4": "Downloadable PDF + emailed to you",
    "match.payNow": "Unlock Now",
    "match.processing": "Processing…",
    "match.payFailed": "Payment failed. Please try again.",
    "match.payCancelled": "Payment was cancelled.",
    "match.verifyFailed": "Payment could not be verified. Please contact support if it was debited.",
    "match.sdkError": "Payment SDK not loaded. Please refresh and try again.",
    "match.generating": "Writing your detailed match report…",
    "match.reportTitle": "Detailed Match Report",
    "match.newCheck": "Check another match",
    "match.creditReady": "You have a match credit — generate the full report",
    "match.generateReport": "Generate full report",

    // ── Consultation ──────────────────────────────────────────────────
    "consult.title": "Book Consultation",
    "consult.subtitle": "Connect with an expert Vedic astrologer for personalized guidance",
    "consult.badge": "50% OFF — LIMITED TIME",
    "consult.priceDuration": "15-minute live consultation",
    "consult.feat1": "Personalized Vedic analysis",
    "consult.feat2": "Marriage & career guidance",
    "consult.feat3": "Remedies & solutions",
    "consult.feat4": "Priority report access",
    "consult.instantTitle": "Talk to an astrologer right now",
    "consult.instantDesc": "Auto-fills today's next available 15-min slot — no waiting.",
    "consult.instantCta": "Consult Now",
    "consult.phoneLabel": "WhatsApp Number (with country code, e.g. +91…)",
    "consult.dateLabel": "Preferred Date",
    "consult.timeLabel": "Preferred Time",
    "consult.concernLabel": "Main Concern",
    "consult.concern.marriage": "Marriage & Relationship",
    "consult.concern.career": "Career & Finance",
    "consult.concern.health": "Health & Wellness",
    "consult.concern.foreign": "Foreign Settlement",
    "consult.bookBtn": "Book Now — {price}",

    // ── Dashboard ─────────────────────────────────────────────────────
    "dash.welcomeBack": "Welcome back",
    "dash.yourPlan": "Your Plan",
    "dash.aiChatUsage": "AI Chat Usage",
    "dash.questionsUsed": "Questions Used",
    "dash.kundliReports": "Kundli Reports",
    "dash.bookings": "Bookings",
    "dash.viewReport": "View Report",
    "dash.rechargeAi": "Recharge AI Chat",

    // ── Promotions ────────────────────────────────────────────────────
    "promo.freeChatTitle": "1 FREE AI Chat Question",
    "promo.freeChatDesc": "Ask our AI astrologer about love, career or destiny — your first question is completely free.",
    "promo.freeChatDescReady": "Your Kundli is ready — ask your FREE AI question about this chart now.",
    "promo.freeChatCta": "Ask FREE Question",
    "promo.heroFreeNote": "First question free — no card needed · Kundli report is free too",
    "promo.consultBadge": "LIMITED TIME — 50% OFF",
    "promo.consultTitle": "Live Astrologer Consultation",
    "promo.consultTitleShort": "Live Astrologer",
    "promo.consultDesc": "15-min private session with an expert Vedic astrologer — personalized remedies included.",
    "promo.consultCta": "Book Now — {price}",
    "promo.consultCtaShort": "Book — {price}",
    "promo.consultEnds": "Offer ends in",
    "promo.hindiTitle": "अब हिंदी में भी!",
    "promo.hindiDesc": "Use AstroFate fully in Hindi.",
    "promo.hindiCta": "हिंदी में देखें",
    "promo.signupGift": "Sign up free & get 1 FREE AI chat question",
    "promo.exitTitle": "Wait — your stars have more to say",
    "promo.exitDesc": "Before you go: get a 15-min private session with an expert Vedic astrologer at 50% OFF. Personalized remedies included.",
    "promo.exitCta": "Claim 50% OFF — Book for {price}",
    "promo.exitDismiss": "No thanks, maybe later",
    "promo.aiChatBadge": "MOST POPULAR",
    "promo.aiChatTitle": "AI Chat Plan",
    "promo.aiChatTitleShort": "AI Chat Plan",
    "promo.aiChatDesc": "Ask 4 in-depth questions to our AI astrologer trained on your Kundli — valid 24 hours.",
    "promo.aiChatCta": "Start Now — {price}",
    "promo.aiChatCtaShort": "Start — {price}",
    "promo.exitFreeBadge": "100% FREE",
    "promo.exitFreeTitle": "Wait — your first question is FREE",
    "promo.exitFreeDesc": "Ask our AI astrologer anything about love, career or destiny before you go — no payment, no card needed.",
    "promo.exitAiTitle": "Wait — unlock 4 AI questions for just {price}",
    "promo.exitAiDesc": "Deep, personalized answers from an AI astrologer trained on your Kundli — valid for 24 hours.",
    "auth.or": "or",
    "auth.googleBtn": "Continue with Google",
  },

  hi: {
    // ── Navbar ────────────────────────────────────────────────────────
    "nav.kundli": "कुंडली",
    "nav.aiChat": "AI चैट",
    "nav.consult": "Consult",
    "nav.blog": "ब्लॉग",
    "nav.dashboard": "Dashboard",
    "nav.admin": "Admin",
    "nav.login": "लॉगिन",
    "nav.signup": "साइन अप",
    "nav.getStarted": "शुरू करें",
    "nav.logout": "लॉगआउट",
    "nav.languageEN": "EN",
    "nav.languageHI": "हिं",

    // ── Home: Hero ────────────────────────────────────────────────────
    "home.badge": "प्राचीन वैदिक ज्ञान। आधुनिक AI तकनीक।",
    "home.heroTitle1": "जानें अपना",
    "home.heroTitle2": "सच्चा मार्ग",
    "home.heroSubtitle": "जीवन, उपचार और प्रगति के लिए व्यक्तिगत मार्गदर्शन",
    "home.heroDesc": "AstroFate आपको खुद को समझने, चुनौतियों का सामना करने और आत्मविश्वास से बढ़ने में मदद करता है — व्यक्तिगत insights, AI guidance और प्राचीन ज्ञान के साथ। रिश्ते, करियर, स्वास्थ्य और जीवन के उद्देश्य में स्पष्टता पाएं।",
    "home.heroTagline": "जवाब पाएं। जागरूकता से उपचार करें। आत्मविश्वास से बढ़ें।",
    "home.heroCtaChat": "मुफ्त AI सवाल पूछें",
    "home.heroCtaKundli": "पूरी कुंडली रिपोर्ट लें",
    "home.statsReports": "रिपोर्ट्स",
    "home.statsUsers": "खुश यूज़र्स",
    "home.statsRating": "रेटिंग",

    // ── Home: Features ────────────────────────────────────────────────
    "home.featuresHeading": "AstroFate क्या देता है",
    "home.feat1Title": "AI कुंडली रिपोर्ट",
    "home.feat1Desc": "ग्रहों की स्थिति, योग, दोष और दशा अवधि के साथ पूरी वैदिक जन्म कुंडली का विश्लेषण।",
    "home.feat1Cta": "रिपोर्ट लें",
    "home.feat2Title": "AI ज्योतिष चैट",
    "home.feat2Desc": "हज़ारों वैदिक ग्रंथों पर प्रशिक्षित हमारे AI ज्योतिषी से गहराई से सवाल पूछें।",
    "home.feat2Cta": "चैट शुरू करें",
    "home.feat3Title": "लाइव ज्योतिषी सलाह",
    "home.feat3Desc": "व्यक्तिगत मार्गदर्शन और उपायों के लिए विशेषज्ञ वैदिक ज्योतिषियों से session बुक करें।",
    "home.feat3Cta": "अभी बुक करें",

    // ── Home: Free question CTA ───────────────────────────────────────
    "home.freeQTitle": "एक मुफ्त सवाल पूछें",
    "home.freeQDesc": "व्यक्तिगत AI ज्योतिष जवाब पाएं — पूरी तरह मुफ्त। कोई card नहीं चाहिए।",
    "home.freeQCta": "मुफ्त चैट शुरू करें",

    // ── Home: Pricing ─────────────────────────────────────────────────
    "home.pricingHeading": "सरल कीमतें",
    "home.priceAiChat": "AI चैट",
    "home.priceAiChatPeriod": "24 घंटे",
    "home.priceAiChatBadge": "सबसे लोकप्रिय",
    "home.priceAiChatFeat1": "4 AI सवाल",
    "home.priceAiChatFeat2": "व्यक्तिगत chart memory",
    "home.priceAiChatFeat3": "उपाय और मार्गदर्शन",
    "home.priceAiChatFeat4": "करियर और प्रेम विश्लेषण",
    "home.priceConsult": "ज्योतिषी से Consult करें",
    "home.priceConsultPeriod": "15 मिनट लाइव चैट",
    "home.priceConsultBadge": "50% छूट",
    "home.priceConsultFeat1": "लाइव human consultation",
    "home.priceConsultFeat2": "Priority रिपोर्ट generation",
    "home.priceConsultFeat3": "व्यक्तिगत उपाय",
    "home.priceConsultFeat4": "शादी और करियर विश्लेषण",
    "home.priceGetStarted": "शुरू करें",

    // ── Home: Testimonials ────────────────────────────────────────────
    "home.testimonialsHeading": "हमारे यूज़र्स क्या कहते हैं",

    // ── Footer ────────────────────────────────────────────────────────
    "footer.tagline": "प्राचीन वैदिक ज्ञान। आधुनिक AI तकनीक। आपके जीवन पथ के लिए व्यक्तिगत मार्गदर्शन।",
    "footer.quickLinks": "Quick Links",
    "footer.home": "होम",
    "footer.aiChat": "AI चैट",
    "footer.bookConsult": "Consultation बुक करें",
    "footer.blog": "ब्लॉग",
    "footer.dashboard": "Dashboard",
    "footer.policies": "Policies",
    "footer.contact": "संपर्क करें",
    "footer.terms": "नियम व शर्तें",
    "footer.refunds": "Refunds और रद्दीकरण",
    "footer.contactHeading": "संपर्क",
    "footer.allRights": "सभी अधिकार सुरक्षित।",
    "footer.payments": "कीमतें INR में · Payments via Cashfree",

    // ── Auth ──────────────────────────────────────────────────────────
    "auth.welcomeBack": "वापसी पर स्वागत है",
    "auth.createAccount": "अपना account बनाएं",
    "auth.tabLogin": "लॉगिन",
    "auth.tabSignup": "साइन अप",
    "auth.nameLabel": "नाम",
    "auth.emailLabel": "ईमेल",
    "auth.passwordLabel": "पासवर्ड",
    "auth.namePh": "आपका पूरा नाम",
    "auth.emailPh": "you@gmail.com",
    "auth.passwordPh": "••••••••",
    "auth.submitLogin": "लॉगिन करें",
    "auth.submitSignup": "Account बनाएं",
    "auth.switchToSignup": "Account नहीं है? साइन अप करें",
    "auth.switchToLogin": "पहले से account है? लॉगिन करें",
    "auth.forgot": "पासवर्ड भूल गए?",

    // ── BirthForm ─────────────────────────────────────────────────────
    "birth.title": "पूरी कुंडली रिपोर्ट पाएं",
    "birth.subtitle": "यहीं से शुरू करें — अपनी जन्म विवरण भरें, personalized वैदिक रिपोर्ट पाएं, फिर AI से चैट करें या लाइव ज्योतिषी से मिलें।",
    "birth.name": "पूरा नाम",
    "birth.namePh": "आपका नाम",
    "birth.day": "दिन",
    "birth.month": "महीना",
    "birth.year": "वर्ष",
    "birth.hour": "घंटा",
    "birth.minute": "मिनट",
    "birth.period": "AM/PM",
    "birth.city": "जन्म शहर",
    "birth.cityPh": "जैसे: Mumbai, Delhi…",
    "birth.generate": "मेरी कुंडली रिपोर्ट बनाएं",
    "birth.generating": "आपकी कुंडली बन रही है…",

    // ── Chat ──────────────────────────────────────────────────────────
    "chat.suggestedHeading": "सुझाए गए सवाल",
    "chat.inputPh": "अपने जीवन, करियर, प्रेम के बारे में कुछ भी पूछें…",
    "chat.sendBtn": "भेजें",
    "chat.loginRequired": "सवाल पूछने के लिए लॉगिन ज़रूरी है",
    "chat.loginRequiredDesc": "मुफ्त account · पहला AI सवाल मुफ्त · सिर्फ 10 सेकंड",
    "chat.loginToStart": "शुरू करने के लिए लॉगिन करें",
    "chat.loginToAsk": "पूछने के लिए लॉगिन करें",
    "chat.noChart": "कोई Chart नहीं है",
    "chat.noChartDesc": "व्यक्तिगत जवाबों के लिए पहले अपनी कुंडली बनाएं",
    "chat.getKundli": "विस्तृत कुंडली रिपोर्ट लें",
    "chat.questionsRemaining": "{n} सवाल बचे हैं",
    "chat.outOfQuestions": "आपके AI सवाल खत्म हो गए हैं। जारी रखने के लिए recharge करें।",
    "chat.rechargeCta": "AI चैट recharge करें — {price}",

    // ── Kundli gate (chat) ────────────────────────────────────────────
    "chart.gateTitle": "पहले अपनी जन्म विवरण भरें",
    "chart.step1": "चरण 1/2 · जन्म विवरण",
    "chart.stepTitle": "पहले आपकी कुंडली पढ़ें",
    "chart.stepDesc": "हर जवाब आपकी ही वैदिक कुंडली से आता है — इसलिए जन्म तिथि, समय और स्थान चाहिए। चुनें या टाइप करें, जैसा आसान लगे।",
    "chart.formTitle": "आपके जन्म विवरण",
    "chart.formSub": "कैलेंडर/घड़ी से चुनें, या “टाइप करें” दबाकर अंक भरें।",
    "chart.yourQuestion": "आपका सवाल सेव है",
    "chart.backToChat": "चैट पर वापस",
    "chart.chartReady": "आपकी कुंडली तैयार है",
    "chart.firstRead": "आपकी कुंडली से पहला पठन",
    "chart.startChat": "अपना सवाल पूछें",
    "chart.detailsToggle": "कुंडली विवरण",
    "chart.gateDesc": "AstroFate AI सिर्फ आपकी कुंडली से जवाब देता है। जन्म तिथि, समय और स्थान भरें — बस 20 सेकंड।",
    "chart.dob": "जन्म तिथि",
    "chart.tob": "जन्म समय",
    "chart.connectBtn": "मेरी कुंडली जोड़ें",
    "chart.connecting": "आपकी कुंडली पढ़ी जा रही है…",
    "chart.genFailed": "कुंडली नहीं बन सकी। विवरण जांच कर फिर कोशिश करें।",
    "chart.connected": "कुंडली जुड़ गई",
    "chart.connectedMsg": "आपकी कुंडली जुड़ गई है। अब सवाल पूछें — हर जवाब आपकी कुंडली से दिया जाएगा।",
    "chart.needDetails": "जवाब देने से पहले मुझे आपकी जन्म विवरण चाहिए — तिथि, समय और स्थान। नीचे फॉर्म भरें, फिर मैं आपकी कुंडली पढ़ूंगा।",
    "chart.loading": "आपकी कुंडली जोड़ी जा रही है…",
    "chart.readyGuest": "आपकी कुंडली तैयार है — मैंने आपका चार्ट पढ़ लिया है। नीचे अपना पहला सवाल पूछें, यह मुफ़्त है। सवाल भेजते समय ही एक मुफ़्त account बनेगा, ताकि आपकी रिपोर्ट और जवाब सुरक्षित रहें।",
    "chat.guestStart": "नीचे अपनी जन्म विवरण भरें — लॉगिन की ज़रूरत नहीं। आपका पहला कुंडली सवाल मुफ़्त है।",
    "chat.guestReady": "आपका चार्ट तैयार है। अपना पहला सवाल लिखें — यह मुफ़्त है।",
    "chat.guestHint": "भेजते समय मुफ़्त account बनेगा · पहला सवाल मुफ़्त · कोई card नहीं",
    "chat.guestPlaceholder": "अपना पहला सवाल मुफ़्त पूछें…",
    "chat.viewFullReport": "पूरी कुंडली रिपोर्ट देखें",
    "auth.questionSaved": "आपका सवाल सेव है — मुफ़्त account बनाएं और जवाब तुरंत दिखेगा",
    "report.saveTitle": "यह रिपोर्ट अपने मुफ़्त account में सेव करें",
    "report.saveDesc": "PDF ईमेल पर पाएं, dashboard से कभी भी खोलें, और इस चार्ट पर 1 मुफ़्त AI सवाल पाएं।",
    "report.saveCta": "मुफ़्त account बनाएं",
    "chart.selectLabel": "किसकी कुंडली",
    "chart.addAnother": "+ नई जन्म विवरण जोड़ें",
    "chart.inputLockedPh": "सवाल पूछने के लिए जन्म विवरण भरें…",
    "chart.chooseTitle": "मैं किसकी कुंडली पढ़ूँ?",
    "chart.choosePrompt": "आपके पास कई कुंडलियाँ सहेजी हैं। कृपया चुनें कि इस सवाल के लिए मैं किसकी कुंडली इस्तेमाल करूँ।",
    "chart.useThis": "यह चुनें",

    // ── Chart at a glance ─────────────────────────────────────────────
    "glance.title": "आपकी कुंडली एक नज़र में",
    "glance.lagna": "लग्न",
    "glance.sun": "सूर्य राशि",
    "glance.moon": "चंद्र राशि",
    "glance.nakshatra": "नक्षत्र",
    "glance.dasha": "वर्तमान दशा",
    "glance.until": "तक",
    "glance.downloadPdf": "PDF डाउनलोड करें",
    "glance.preparingPdf": "PDF तैयार हो रही है…",
    "glance.pdfFailed": "PDF नहीं बन सकी। फिर कोशिश करें।",
    "pdf.langEn": "English",
    "pdf.langHi": "हिन्दी",
    "pdf.hindiWait": "आपकी रिपोर्ट हिंदी में तैयार हो रही है — पहली बार एक मिनट तक लग सकता है।",
    "pdf.emailBtn": "यह PDF मुझे ईमेल करें",
    "pdf.emailing": "भेज रहे हैं…",
    "pdf.emailed": "भेज दिया! अपना inbox देखें:",
    "pdf.emailFailed": "ईमेल नहीं भेजा जा सका। फिर कोशिश करें।",
    "pdf.autoSent": "यह रिपोर्ट हमने आपको ईमेल भी कर दी है।",

    // ── Daily horoscope ───────────────────────────────────────────────
    "horo.title": "आज का राशिफल",
    "horo.loading": "आपकी कुंडली के अनुसार आज के गोचर पढ़े जा रहे हैं…",
    "horo.failed": "आज का राशिफल लोड नहीं हो सका। फिर कोशिश करें।",
    "horo.retry": "फिर कोशिश करें",
    "horo.loginNeeded": "अपनी कुंडली से आज की भविष्यवाणी देखने के लिए लॉगिन करें।",
    "horo.askAi": "आज के बारे में AI से पूछें",
    "horo.askPrefill": "आज का राशिफल मेरे करियर के लिए क्या कहता है?",
    "horo.dashTitle": "आज का राशिफल",
    "horo.dashCta": "आज का राशिफल पढ़ें",
    "horo.dashEmpty": "रोज़ की कुंडली-आधारित भविष्यवाणी के लिए अपनी कुंडली बनाएं।",

    // ── Kundli Matching ───────────────────────────────────────────────
    "match.navLabel": "कुंडली मिलान",
    "match.title": "कुंडली मिलान",
    "match.subtitle": "36 में से मुफ्त अष्टकूट मिलान स्कोर — विस्तृत रिपोर्ट {price} में।",
    "match.partner1": "वर (Partner 1)",
    "match.partner2": "वधू (Partner 2)",
    "match.useSaved": "सेव की गई कुंडली चुनें",
    "match.manual": "मैन्युअल भरें",
    "match.checkBtn": "मिलान देखें — मुफ्त",
    "match.checking": "दोनों कुंडलियां पढ़ी जा रही हैं…",
    "match.failed": "मिलान नहीं हो सका। विवरण जांच कर फिर कोशिश करें।",
    "match.scoreOf": "36 में से",
    "match.kootaTable": "कूट-वार विश्लेषण",
    "match.koota": "कूट",
    "match.points": "अंक",
    "match.details": "विवरण",
    "match.meaning": "क्या दर्शाता है",
    "match.doshas": "मिले दोष",
    "match.noDoshas": "कोई बड़ा दोष नहीं मिला",
    "match.manglik": "मांगलिक",
    "match.unlockCta": "पूरी मिलान रिपोर्ट खोलें — {price}",
    "match.unlockTitle": "पूरी मिलान रिपोर्ट",
    "match.unlockDesc": "दोनों कुंडलियों से लिखा गया विस्तृत वैदिक विश्लेषण।",
    "match.feat1": "कूट-वार विशेषज्ञ विश्लेषण",
    "match.feat2": "भावनात्मक, शारीरिक और पारिवारिक अनुकूलता",
    "match.feat3": "दोषों का असर और उपाय",
    "match.feat4": "PDF डाउनलोड + ईमेल",
    "match.payNow": "अभी खोलें",
    "match.processing": "प्रोसेस हो रहा है…",
    "match.payFailed": "भुगतान असफल। फिर कोशिश करें।",
    "match.payCancelled": "भुगतान रद्द कर दिया गया।",
    "match.verifyFailed": "भुगतान वेरिफाई नहीं हो सका। राशि कटी हो तो सपोर्ट से संपर्क करें।",
    "match.sdkError": "Payment SDK लोड नहीं हुआ। पेज रिफ्रेश करें।",
    "match.generating": "आपकी विस्तृत मिलान रिपोर्ट लिखी जा रही है…",
    "match.reportTitle": "विस्तृत मिलान रिपोर्ट",
    "match.newCheck": "दूसरा मिलान देखें",
    "match.creditReady": "आपके पास मिलान क्रेडिट है — पूरी रिपोर्ट बनाएं",
    "match.generateReport": "पूरी रिपोर्ट बनाएं",

    // ── Consultation ──────────────────────────────────────────────────
    "consult.title": "Consultation बुक करें",
    "consult.subtitle": "व्यक्तिगत मार्गदर्शन के लिए विशेषज्ञ वैदिक ज्योतिषी से जुड़ें",
    "consult.badge": "50% छूट — सीमित समय",
    "consult.priceDuration": "15-मिनट लाइव consultation",
    "consult.feat1": "व्यक्तिगत वैदिक विश्लेषण",
    "consult.feat2": "शादी और करियर मार्गदर्शन",
    "consult.feat3": "उपाय और समाधान",
    "consult.feat4": "Priority रिपोर्ट access",
    "consult.instantTitle": "अभी ज्योतिषी से बात करें",
    "consult.instantDesc": "आज का अगला available 15-मिनट slot auto-fill होता है — कोई इंतज़ार नहीं।",
    "consult.instantCta": "अभी Consult करें",
    "consult.phoneLabel": "WhatsApp नंबर (देश कोड के साथ, जैसे +91…)",
    "consult.dateLabel": "पसंदीदा तारीख",
    "consult.timeLabel": "पसंदीदा समय",
    "consult.concernLabel": "मुख्य चिंता",
    "consult.concern.marriage": "शादी और रिश्ते",
    "consult.concern.career": "करियर और पैसा",
    "consult.concern.health": "स्वास्थ्य",
    "consult.concern.foreign": "विदेश settlement",
    "consult.bookBtn": "अभी बुक करें — {price}",

    // ── Dashboard ─────────────────────────────────────────────────────
    "dash.welcomeBack": "वापसी पर स्वागत है",
    "dash.yourPlan": "आपका plan",
    "dash.aiChatUsage": "AI चैट उपयोग",
    "dash.questionsUsed": "उपयोग किए गए सवाल",
    "dash.kundliReports": "कुंडली रिपोर्ट्स",
    "dash.bookings": "Bookings",
    "dash.viewReport": "रिपोर्ट देखें",
    "dash.rechargeAi": "AI चैट recharge करें",

    // ── Promotions ────────────────────────────────────────────────────
    "promo.freeChatTitle": "1 मुफ्त AI चैट सवाल",
    "promo.freeChatDesc": "प्रेम, करियर या भाग्य के बारे में हमारे AI ज्योतिषी से पूछें — आपका पहला सवाल बिल्कुल मुफ्त।",
    "promo.freeChatDescReady": "आपकी कुंडली तैयार है — इस chart के बारे में अपना मुफ्त AI सवाल अभी पूछें।",
    "promo.freeChatCta": "मुफ्त सवाल पूछें",
    "promo.heroFreeNote": "पहला सवाल मुफ़्त — कोई card नहीं · कुंडली रिपोर्ट भी मुफ़्त",
    "promo.consultBadge": "सीमित समय — 50% छूट",
    "promo.consultTitle": "लाइव ज्योतिषी Consultation",
    "promo.consultTitleShort": "लाइव ज्योतिषी",
    "promo.consultDesc": "विशेषज्ञ वैदिक ज्योतिषी के साथ 15-मिनट निजी session — व्यक्तिगत उपाय शामिल।",
    "promo.consultCta": "अभी बुक करें — {price}",
    "promo.consultCtaShort": "बुक करें — {price}",
    "promo.consultEnds": "Offer खत्म होगा",
    "promo.hindiTitle": "अब हिंदी में भी!",
    "promo.hindiDesc": "AstroFate पूरी तरह हिंदी में इस्तेमाल करें।",
    "promo.hindiCta": "हिंदी में देखें",
    "promo.signupGift": "मुफ्त साइन अप करें और 1 मुफ्त AI चैट सवाल पाएं",
    "promo.exitTitle": "रुकिए — आपके सितारे कुछ और कहना चाहते हैं",
    "promo.exitDesc": "जाने से पहले: विशेषज्ञ वैदिक ज्योतिषी के साथ 15-मिनट निजी session पाएं — 50% छूट पर। व्यक्तिगत उपाय शामिल।",
    "promo.exitCta": "50% छूट पाएं — {price} में बुक करें",
    "promo.exitDismiss": "नहीं धन्यवाद, बाद में",
    "promo.aiChatBadge": "सबसे लोकप्रिय",
    "promo.aiChatTitle": "AI चैट Plan",
    "promo.aiChatTitleShort": "AI चैट Plan",
    "promo.aiChatDesc": "आपकी कुंडली पर प्रशिक्षित AI ज्योतिषी से 4 गहरे सवाल पूछें — 24 घंटे के लिए मान्य।",
    "promo.aiChatCta": "अभी शुरू करें — {price}",
    "promo.aiChatCtaShort": "शुरू करें — {price}",
    "promo.exitFreeBadge": "100% मुफ्त",
    "promo.exitFreeTitle": "रुकिए — आपका पहला सवाल मुफ्त है",
    "promo.exitFreeDesc": "जाने से पहले प्रेम, करियर या भाग्य के बारे में हमारे AI ज्योतिषी से कुछ भी पूछें — कोई payment नहीं, कोई card नहीं।",
    "promo.exitAiTitle": "रुकिए — सिर्फ {price} में 4 AI सवाल unlock करें",
    "promo.exitAiDesc": "आपकी कुंडली पर प्रशिक्षित AI ज्योतिषी से गहरे, व्यक्तिगत जवाब — 24 घंटे के लिए मान्य।",
    "auth.or": "या",
    "auth.googleBtn": "Google से जारी रखें",
  },
};
